import { Color } from '@pixi/color';
import { Container, Graphics } from 'pixi.js-legacy';

import { themingInstance } from '@exchange/libs/utils/theming/src';

export default class MyOrders extends Container {
  public orders!: {
    openOrders: Array<[number, number]>;
    stopOrders: Array<[number, number]>;
  };

  private dotRadius = 2.5;

  private dotX: number;

  private maxY: number;

  private get fillColor() {
    return new Color(themingInstance.getColor('--v-theme-primary')).toNumber();
  }

  constructor({ dotX, maxY }) {
    super();

    this.dotX = dotX;
    this.maxY = maxY;
  }

  public draw(graphics: Graphics) {
    if (!this.orders) {
      return;
    }

    graphics.beginFill(this.fillColor);
    graphics.lineStyle(0);

    this.orders.openOrders.forEach(([_price, y]) => {
      if (y > 0 && y < this.maxY) {
        graphics.drawCircle(this.dotX, y - this.dotRadius / 2, this.dotRadius);
      }
    });

    this.orders.stopOrders.forEach(([_price, y]) => {
      if (y > 0 && y < this.maxY) {
        graphics.drawCircle(this.dotX + 4, y - this.dotRadius / 2, this.dotRadius);
      }
    });

    graphics.lineStyle(0);
    graphics.endFill();
  }
}
